import { modelUtils } from "@cayo/core/components/Form/modelUtils/utils";
import { UIInteraction } from "@cayo/shared/hooks/useUIInteraction";
import { showApprovalConfirmationMessages } from "./messages";

const USER_COMMENT_PARAMETER = "UserComment";

type ShowApprovalConfirmationParams = {
  parameters: any[] | undefined;
  uiInteraction: UIInteraction;
};

export const showApprovalConfirmation = async ({
  parameters,
  uiInteraction,
}: ShowApprovalConfirmationParams) => {
  const userComment = await uiInteraction.prompt({
    title: uiInteraction.intl.formatMessage(showApprovalConfirmationMessages.title),
    text: uiInteraction.intl.formatMessage(showApprovalConfirmationMessages.text),
    fieldName: USER_COMMENT_PARAMETER,
    fieldLabel: uiInteraction.intl.formatMessage(showApprovalConfirmationMessages.userCommentLabel),
    initialValue: modelUtils.getParameterValue(parameters, USER_COMMENT_PARAMETER),
    required: true,
  });

  return modelUtils.setParameterValue(parameters, USER_COMMENT_PARAMETER, userComment);
};
